export default class HeaderVideoController {
    constructor() {
        this.video = document.querySelector('.js-video');
        this.videoWrapper = document.querySelector('.js-video-wrapper');
        this.playVideoBtn = document.querySelector('.js-play-video');
        this.isPlaying = false;

        if (this.video && this.playVideoBtn) {
            this.init();
        }
    }

    init() {
        this.playVideoBtn.addEventListener('click', () => {
            if (this.isPlaying) {
                return;
            }

            this.video.setAttribute("controls", "controls");
            this.isPlaying = true;
            this.video.play();
            this.videoWrapper.classList.add('is-playing');
        });

        this.video.addEventListener('click', () => {
            if (this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2) {
                this.video.removeAttribute("controls");
                this.isPlaying = false;
                this.videoWrapper.classList.remove('is-playing');
                this.video.pause();
            }
        });
    }
}


